import { BackgroundContainer } from "@client/controls/Style/Background/container";
import { type WithChildren } from "@client/types/WithChildren";
import * as React from "react";

export type Props = WithChildren & {
  style?: React.CSSProperties;
};
export default (props: Props) => (
  <div id="wsc_body_container" style={props.style}>
    <BackgroundContainer containerSelector="#wsc_body_container" prefix="body" />

    {props.children}
  </div>
);
